export default "__VITE_ASSET__C6tU7RXy__"